import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ValueView from '../views/ValueView.vue'
import ServiceView from '../views/ServiceView.vue'
import ContactView from '../views/ContactView.vue'
import ActivitiesView from '../views/ActivitiesView.vue'
import NursingView from '../views/NursingView.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/Value',
    name: 'value',
    component: ValueView
  },
  {
    path: '/Service',
    //name: 'service',
    //component: ServiceView,
    children: [
      {
        path: '',
        name: 'Service',
        component: ServiceView,
      },
      {
        path: 'Nursing',
        component: NursingView,
      },
      {
        path: 'Activities',
        component: ActivitiesView,
      },
    ],
  },
  {
    path: '/Contact',
    name: 'contact',
    component: ContactView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
